import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@fuse/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FusePipesModule } from 'app/core/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { FuseSidebarModule } from '@fuse/components';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { AnswerStatusLogComponent } from './answer-status-log.component';
import { BarRatingModule } from 'ngx-bar-rating';

@NgModule({
    declarations: [
        AnswerStatusLogComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule,
        FusePipesModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        DatePickerModule,
        FuseSidebarModule,
        NgxMatSelectSearchModule,
        BarRatingModule
    ],
    entryComponents: [
        AnswerStatusLogComponent
    ],
    exports: [
        AnswerStatusLogComponent
    ]
})

export class AnswerStatusLogModule {

}